import { FontEntry } from '../../types/font'

export const cinzel: FontEntry = {
  displayName: 'Cinzel',
  weights: {},
  variables: {
    normal: {
      file: 'Cinzel-VariableFont_wght',
      extension: 'ttf',
      format: 'truetype',
      weightRange: [400, 900]
    }
  }
}
